import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import data from 'emoji-mart/data/apple.json'

import { EmojiPropTypes, getEmojiTitle } from '../utils'

import EmojiViewer from '../Viewer'

class EmojiPickerPreview extends React.PureComponent {
  static propTypes = {
    index: PropTypes.number.isRequired,
    selectedEmoji: EmojiPropTypes,
    onClickEmoji: PropTypes.func.isRequired,
  }

  getPlaceholderParams() {
    return {
      title: 'Pick one',
      shortname: 'pick_them_all',
      emoji: data.emojis.point_up,
    }
  }

  getEmptyParams() {
    return {
      title: 'No found',
      shortname: '404',
      emoji: data.emojis.thinking_face,
    }
  }

  getSelectedParams() {
    const emoji = this.props.selectedEmoji
    return {
      title: getEmojiTitle(emoji),
      shortname: emoji.id,
      emoji: this.props.selectedEmoji,
    }
  }

  getParams() {
    const { index, selectedEmoji } = this.props
    if (index === -1) {
      return this.getPlaceholderParams()
    }
    if (selectedEmoji) {
      this.getSelectedParams()
    }
    return this.getEmptyParams()
  }

  render() {
    const { index, onClickEmoji } = this.props

    const { title, emoji, shortname } = this.getParams()

    return (
      <div
        className={classNames(
          'flexbox flexbox-align-center flexbox-no-shrink',
          'line-height-normal font-size-large',
          'border-top-small border-shade-50',
          'padding-vertical-small padding-horizontal-small'
        )}
      >
        <div className="flexbox-no-shrink margin-right-small">
          <EmojiViewer
            index={index}
            emoji={emoji}
            onClick={onClickEmoji}
            className="pointer background-shade-45-on-hover"
          />
        </div>
        <div className="flexbox-grow padding-right-small ellipsis">
          <div className="font-weight-semibold shade-05 ellipsis margin-bottom-smaller">
            {title}
          </div>
          <div className="shade-10 ellipsis">:{shortname}:</div>
        </div>
      </div>
    )
  }
}

export default EmojiPickerPreview
